export const pluralize = (vals: string[]): string => {
  switch (vals.length) {
    case 0:
      return "";
    case 1:
      return vals[0];
    case 2:
      return `${vals[0]} and ${vals[1]}`;
    default:
      return `${vals.slice(0, vals.length - 1).join(", ")}, and ${vals[vals.length - 1]}`;
  }
};
